import { render, staticRenderFns } from "./PageManualBuildingEnvelope.vue?vue&type=template&id=da20ac88&"
import script from "./PageManualBuildingEnvelope.vue?vue&type=script&lang=js&"
export * from "./PageManualBuildingEnvelope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports